<template>
    <div class="filters-container">

        <div class="filters">

            <!-- Searh Input -->
            <ais-search-box />

            <!-- Search by Region -->
            <ais-refinement-list class="region-tags" attribute="region.name"></ais-refinement-list>

            <!-- Ogther Filter Button -->
            <button type="button" class="btn-filters" @click.prevent="openFilters">
                Filter
                <svg class="filters"><use xlink:href="#filters"></use></svg>
            </button>
        </div>

        <!-- Other Filers -->
        <div v-show="showFilterSlider" class="filters-slider">

            <Transition enter-active-class="animate__animated animate__fadeIn"
                        leave-active-class="animate__animated animate__fadeOut">

                <div class="filters-backdrop" v-show="showFilterSlider" @click="closeFilters()"></div>

            </Transition>

            <Transition enter-active-class="animate__animated animate__fadeInRight"
                        leave-active-class="animate__animated animate__fadeOutRight">

                <div class="filters-content" v-show="showFilterSlider">

                    <div class="header">
                        <h2>Filter Destinations</h2>
                        <button class="btn-close" @click="closeFilters()">
                            Close
                            <svg class="close"><use xlink:href="#close"></use></svg>
                        </button>
                    </div>

                   <div class="body">
                       <div class="section">
                           <h3>By Region</h3>
                           <ais-refinement-list :limit="21" class="ais-checkboxes chk-regions" attribute="region.name"></ais-refinement-list>
                       </div>
                       <div class="section">
                           <h3>By Tag</h3>
                           <ais-refinement-list :limit="21"  class="ais-checkboxes chk-tags" attribute="tags"></ais-refinement-list>
                       </div>
                       <div class="section">
                           <h3>By Country</h3>
                           <ais-refinement-list :limit="21"  class="ais-checkboxes chk-tags" attribute="country"></ais-refinement-list>
                       </div>
                   </div>

                    <div class="footer">

                        <ais-clear-refinements>
                            <template v-slot:resetLabel>Clear</template>
                        </ais-clear-refinements>

                        <button type="button" class="btn-apply" @click="closeFilters()">
                            Close Filters
                            <ais-stats>
                                <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                                    <p>{{ nbHits }} results.</p>
                                </template>
                            </ais-stats>
                        </button>
                    </div>
                </div>

            </Transition>
        </div>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],

    data() {
        return {
            slick: null,
            showFilterSlider: false,
        }
    },

    methods:{
        openFilters(){
            this.showFilterSlider = !this.showFilterSlider
            $('body').addClass('no-scroll')
        },

        closeFilters(){
            this.showFilterSlider = false
            $('body').removeClass('no-scroll')
        }
    }
}
</script>

